import {
    faCheckCircle,
    faExclamationCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "utils/hooks/use-translation.hook";
import LoadSpinner from "./load-spinner";

type RequestStatusMessageType = {
    type: "error" | "loading" | "success";
    loadMessage?: string;
    errorMessage?: string;
    successMessage?: string;
};

const RequestStatusMessage = ({
    type,
    errorMessage,
    loadMessage,
    successMessage,
}: RequestStatusMessageType) => {
    const translate = useTranslation();

    if (!loadMessage) loadMessage = translate("app.gis.loading");
    if (!errorMessage) errorMessage = translate("app.general.generic.error");
    if (!successMessage)
        successMessage = translate("app.general.generic.success");

    const defineMessage = () => {
        if (type === "loading") return loadMessage;
        return type === "error" ? errorMessage : successMessage;
    };

    return (
        <div className="c-requests-status-message">
            <div className="c-requests-status-message__icon-container">
                {type === "loading" ? (
                    <div className="c-requests-status-message__loading">
                        <LoadSpinner />
                    </div>
                ) : (
                    <FontAwesomeIcon
                        className={`c-requests-status-message__icon--${type}`}
                        icon={
                            type === "error"
                                ? faExclamationCircle
                                : faCheckCircle
                        }
                    />
                )}
            </div>
            <div>
                <span className="c-requests-status-message__message">
                    {defineMessage()}
                </span>
            </div>
        </div>
    );
};

export default RequestStatusMessage;
